export default __webpack_public_path__ + "static/samuel-2ed6dbf72b8e7844b1c84c11d4d2912c.jpg";